'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var onSubmit = function () {
	var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
		var recaptchaResponse, body, notValid, res;
		return _regenerator2.default.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						e.preventDefault();

						if (this.props.canSubmit) {
							_context.next = 3;
							break;
						}

						return _context.abrupt('return');

					case 3:
						if (!this.honeypot.value) {
							_context.next = 6;
							break;
						}

						console.error('Honeypot value is set. Cannot submit form.');
						return _context.abrupt('return');

					case 6:

						this.setState({
							loading: true,
							error: false,
							success: false
						});

						recaptchaResponse = this.form.querySelector('#g-recaptcha-response');

						if (!(recaptchaResponse && !recaptchaResponse.value)) {
							_context.next = 10;
							break;
						}

						return _context.abrupt('return', this.onError(this.props.recatpchaError));

					case 10:
						body = new FormData(this.form);
						_context.next = 13;
						return this.props.validate(body);

					case 13:
						notValid = _context.sent;

						if (!notValid) {
							_context.next = 16;
							break;
						}

						return _context.abrupt('return', this.setState({
							loading: false,
							error: false,
							success: false
						}));

					case 16:

						this.props.onSubmit(body);

						_context.next = 19;
						return (0, _isomorphicFetch2.default)(this.props.action, {
							method: 'POST',
							body: body
						});

					case 19:
						res = _context.sent;

						if (!(res.status !== 200)) {
							_context.next = 22;
							break;
						}

						return _context.abrupt('return', this.onError(this.props.statusError));

					case 22:
						this.onSuccess(body);

					case 23:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function onSubmit(_x) {
		return _ref.apply(this, arguments);
	};
}();

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = onSubmit;
module.exports = exports['default'];
//# sourceMappingURL=on-submit.js.map